import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  marginFields,
  marginProps,
  MarginProps,
  MarginType,
} from '../../puck/reusable-props/NewMargin';
import {
  paddingFields,
  paddingProps,
  PaddingProps,
  PaddingType,
} from '../../puck/reusable-props/padding';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { ReduxSelectorProps } from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import WithAccordion from '../customComponents/CustomAccordion';
import { Switch } from '@mui/material';
import QuillFieldRenderer from '../carousel review/QuillFieldRenderer';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import NewMarginFiled from '../../puck/reusable-props/newMarginField';
import PaddingComponent from '../customComponents/PaddingComponent';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import { useEffect, useState } from 'react';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../customComponents/BackgroungColorComponent';
import JustifyContent, {
  IJustifyContentProps,
} from '../blocks/Container/justify-content';
import TextAlign, { ITextAlignProps } from './TextAlign';
import { IAsset } from '../../interface/apiServiceInterface';
import { AxiosInstance } from 'axios';
import { ImageSelector } from '../../../components/common/image-selector/ImageSelector';

export interface CustomerProps extends ReduxSelectorProps {
  baseService: AxiosInstance;
}
export type TextDropdownProps = MarginProps &
  PaddingProps &
  showComponentProps & {
    defaultExpanded: boolean;
    title: {
      text: string;
      justifyContent: IJustifyContentProps;
      bgColorCollapsed: IBackgroundProps;
      bgColorExpanded: IBackgroundProps;
      hoverColor: string;
      margin: MarginType;
      padding: PaddingType;
      border: IBorderValueProps;
    };
    description: {
      text: string;
      backgroundColor: IBackgroundProps;
      textAlign: ITextAlignProps;
      margin: MarginType;
      padding: PaddingType;
      border: IBorderValueProps;
    };
    border: IBorderValueProps;
    background: {
      color: string;
      isInherit: boolean;
    };
    dropdownArrow: {
      showArrow: boolean;
      arrowColor: string;
      arrowSize: number;
      showDefaultIcon: boolean;
      openImage: IAsset;
      closeImage: IAsset;
    };
  };
export const defaultImage = {
  fileName: '',
  imageUrl: '',
  imageType: 'upload',
  storeID: '',
  code: '',
};

export const TextDropdown = ({
  useAppSelector,
  baseService,
}: CustomerProps): ComponentConfig<TextDropdownProps> => {
  return {
    label: (
      <CustomTooltip title="Text Dropdown">
        <span>Text Dropdown</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      title: {
        type: 'custom',
        label: 'Title',
        render: ({ value, onChange }) => (
          <WithAccordion title="Title">
            <QuillFieldRenderer
              label="Text"
              value={value.text}
              onChange={text => onChange({ ...value, text })}
              id={1}
            />
            <BackgroungColorComponent
              value={value.bgColorCollapsed}
              onChange={bgColorCollapsed =>
                onChange({ ...value, bgColorCollapsed })
              }
              title="Collapsed Background"
            />
            <BackgroungColorComponent
              value={value.bgColorExpanded}
              onChange={bgColorExpanded =>
                onChange({ ...value, bgColorExpanded })
              }
              title="Expanded Background"
            />
            <WithAccordion title="Hover Color">
              <ColorPicker
                value={value.hoverColor}
                onChange={hoverColor => onChange({ ...value, hoverColor })}
                label={'Hover Color'}
                tooltip={'hoverColor'}
              />
            </WithAccordion>
            <JustifyContent
              value={value.justifyContent}
              onChange={justifyContent =>
                onChange({ ...value, justifyContent })
              }
              title="Justify Content"
            />
            <NewMarginFiled
              value={value.margin}
              onChange={margin => onChange({ ...value, margin })}
              title="Margin"
            />
            <PaddingComponent
              value={value.padding}
              onChange={padding => onChange({ ...value, padding })}
              title="Padding"
            />
            <Border
              value={value.border}
              onChange={border => onChange({ ...value, border })}
              title="Border"
            />
          </WithAccordion>
        ),
      },
      description: {
        type: 'custom',
        label: 'Description',
        render: ({ value, onChange }) => (
          <WithAccordion title="Description">
            <QuillFieldRenderer
              label="Text"
              value={value.text}
              onChange={text => onChange({ ...value, text })}
              id={2}
            />
            <BackgroungColorComponent
              value={value.backgroundColor}
              onChange={backgroundColor =>
                onChange({ ...value, backgroundColor })
              }
            />
            <TextAlign
              value={value.textAlign}
              onChange={textAlign => onChange({ ...value, textAlign })}
              title="Text Align"
            />
            <NewMarginFiled
              value={value.margin}
              onChange={margin => onChange({ ...value, margin })}
              title="Margin"
            />
            <PaddingComponent
              value={value.padding}
              onChange={padding => onChange({ ...value, padding })}
              title="Padding"
            />
            <Border
              value={value.border}
              onChange={border => onChange({ ...value, border })}
              title="Border"
            />
          </WithAccordion>
        ),
      },
      defaultExpanded: {
        type: 'radio',
        label: 'Default Expanded',
        options: [
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ],
      },
      dropdownArrow: {
        type: 'custom',
        label: 'Dropdown Icon',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Dropdown Icon">
              <>
                <div className="flex items-center justify-between my-1">
                  <span className="font-bold">Show Icon</span>
                  <Switch
                    className="flex justify-between items-center"
                    checked={value?.showArrow}
                    onChange={e => {
                      const selectedValue = e.target.checked;
                      onChange({
                        ...value,
                        showArrow: selectedValue,
                      });
                    }}
                  />
                </div>

                {value?.showArrow && (
                  <>
                    <div className="flex items-center justify-between my-1">
                      <span className="font-bold">Show Default Icon</span>
                      <Switch
                        className="flex justify-between items-center"
                        checked={value?.showDefaultIcon}
                        onChange={e => {
                          const selectedValue = e.target.checked;
                          onChange({
                            ...value,
                            showDefaultIcon: selectedValue,
                          });
                        }}
                      />
                    </div>
                    {!value?.showDefaultIcon && (
                      <>
                        <div className="mb-4">
                          <FieldLabel label="Open Icon">
                            <ImageSelector
                              selectedImage={value?.openImage || defaultImage}
                              handleSubmit={openImage =>
                                onChange({
                                  ...value,
                                  openImage,
                                })
                              }
                              baseService={baseService}
                            />
                          </FieldLabel>
                        </div>
                        <div className="mb-4">
                          <FieldLabel label="Close Icon">
                            <ImageSelector
                              selectedImage={value?.closeImage || defaultImage}
                              handleSubmit={closeImage =>
                                onChange({
                                  ...value,
                                  closeImage,
                                })
                              }
                              baseService={baseService}
                            />
                          </FieldLabel>
                        </div>
                      </>
                    )}
                    {value?.showDefaultIcon && (
                      <ColorPicker
                        value={value?.arrowColor}
                        onChange={color =>
                          onChange({
                            ...value,
                            arrowColor: color,
                          })
                        }
                        label={'Icon Color'}
                        tooltip={'arrowColor'}
                      />
                    )}
                    <div className="mb-4">
                      <FieldLabel
                        label={
                          (
                            <CustomTooltip title="arrowSize">
                              <span>Icon Size</span>
                            </CustomTooltip>
                          ) as React.ReactNode as string
                        }>
                        <input
                          type="number"
                          value={value?.arrowSize}
                          onChange={e =>
                            onChange({
                              ...value,
                              arrowSize: Number(e.target.value),
                            })
                          }
                          className="w-full border rounded px-2 py-3 text-sm"
                        />
                      </FieldLabel>
                    </div>
                  </>
                )}
              </>
            </WithAccordion>
          );
        },
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        label: 'Border',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      title: {
        text: '<p style="line-height:1.5; style="font-size: 18px;"><span>Frequently Asked Questions</span></p>',
        justifyContent: {
          deviceType: 'desktop',
          justify: {
            mobile: 'justify-between',
            tablet: 'justify-between',
            desktop: 'justify-between',
          },
        },
        bgColorCollapsed: {
          color: '#FFFFFF',
          isInherit: false,
        },
        bgColorExpanded: {
          color: '#FFFFFF',
          isInherit: false,
        },
        hoverColor: '#F3F4F6',
        margin: marginProps.margin,
        padding: paddingProps.padding,
        border: borderProps.border,
      },
      description: {
        text: '<p style="line-height:1.5; style="font-size: 18px;"><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>',
        backgroundColor: {
          color: '#FFFFFF',
          isInherit: false,
        },
        textAlign: {
          deviceType: 'desktop',
          align: {
            mobile: 'text-left',
            tablet: 'text-left',
            desktop: 'text-left',
          },
        },
        margin: marginProps.margin,
        padding: paddingProps.padding,
        border: borderProps.border,
      },
      defaultExpanded: false,
      dropdownArrow: {
        showArrow: true,
        arrowColor: '#000000',
        arrowSize: 18,
        showDefaultIcon: true,
        openImage: defaultImage,
        closeImage: defaultImage,
      },
      margin: marginProps.margin,
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '10',
          mobile: '10',
          tablet: '10',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '10',
          mobile: '10',
          tablet: '10',
        },
      },
      ...borderProps,
      background: {
        color: '#FFFFFF',
        isInherit: false,
      },
    },
    render: ({
      margin,
      padding,
      defaultExpanded,
      title,
      description,
      showComponent,
      editMode,
      border,
      background,
      dropdownArrow,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const [isOpen, setIsOpen] = useState<boolean>(defaultExpanded);
      const [isHovered, setIsHovered] = useState<boolean>(false);
      useEffect(() => {
        setIsOpen(defaultExpanded);
      }, [defaultExpanded]);

      const toggleOpen = () => {
        setIsOpen(!isOpen);
      };
      const hasCustomOpenIcon = dropdownArrow?.openImage?.imageUrl;
      const hasCustomCloseIcon = dropdownArrow?.closeImage?.imageUrl;
      const showDefaultIcon = dropdownArrow?.showDefaultIcon;

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              className={`border-b border-gray-200 ${border?.borderStyle?.[currentDeviceType]}`}
              style={{
                ...getNewMarginStyles(margin, currentDeviceType),
                ...getPaddingStyles(padding, currentDeviceType),
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
                ...getBorderProps(border, currentDeviceType),
              }}>
              <div
                className={`cursor-pointer flex ${title?.justifyContent?.justify?.[currentDeviceType]} items-center text-editor-content ${title?.border?.borderStyle?.[currentDeviceType]}`}
                onClick={toggleOpen}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                aria-expanded={isOpen}
                role="button"
                style={{
                  backgroundColor: isHovered
                    ? title.hoverColor
                    : isOpen
                      ? title.bgColorExpanded?.isInherit
                        ? 'inherit'
                        : title.bgColorExpanded?.color
                      : title.bgColorCollapsed?.isInherit
                        ? 'inherit'
                        : title.bgColorCollapsed?.color,
                  ...getBorderProps(title.border, currentDeviceType),
                  ...getNewMarginStyles(title.margin, currentDeviceType),
                  ...getPaddingStyles(title.padding, currentDeviceType),
                }}>
                <div dangerouslySetInnerHTML={{ __html: title.text }} />

                {dropdownArrow?.showArrow && (
                  <>
                    {showDefaultIcon ? (
                      <svg
                        style={{
                          width: `${dropdownArrow?.arrowSize || 16}px`,
                          height: `${dropdownArrow?.arrowSize || 16}px`,
                        }}
                        fill="none"
                        stroke={dropdownArrow?.arrowColor || 'currentColor'}
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d={isOpen ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'}
                        />
                      </svg>
                    ) : (
                      <>
                        {isOpen && hasCustomCloseIcon ? (
                          <img
                            src={`${process.env.REACT_APP_S3_BUCKET_URL}${dropdownArrow.closeImage.imageUrl}`}
                            alt="dropdown icon"
                            style={{
                              width: `${dropdownArrow?.arrowSize || 16}px`,
                              height: `${dropdownArrow?.arrowSize || 16}px`,
                              objectFit: 'contain',
                            }}
                          />
                        ) : (
                          !isOpen &&
                          hasCustomOpenIcon && (
                            <img
                              src={`${process.env.REACT_APP_S3_BUCKET_URL}${dropdownArrow.openImage.imageUrl}`}
                              alt="dropdown icon"
                              style={{
                                width: `${dropdownArrow?.arrowSize || 16}px`,
                                height: `${dropdownArrow?.arrowSize || 16}px`,
                                objectFit: 'contain',
                              }}
                            />
                          )
                        )}
                      </>
                    )}
                  </>
                )}
              </div>

              {isOpen && (
                <div
                  className={`pt-1 text-editor-content ${description?.textAlign?.align?.[currentDeviceType]} ${description?.border?.borderStyle?.[currentDeviceType]}`}
                  dangerouslySetInnerHTML={{ __html: description.text }}
                  style={{
                    ...getNewMarginStyles(
                      description.margin,
                      currentDeviceType,
                    ),
                    ...getPaddingStyles(description.padding, currentDeviceType),
                    ...getBorderProps(description.border, currentDeviceType),
                    backgroundColor: description.backgroundColor?.isInherit
                      ? 'inherit'
                      : description.backgroundColor?.color,
                  }}
                />
              )}
            </div>
          )}
        </>
      );
    },
  };
};
